import React, { useState } from 'react'
import { postGDCDetaliedPlan } from '@auteco/services/gdcServices'
import { Button, Dialog, DialogContent, DialogTitle, TextField, Typography, makeStyles } from '@material-ui/core'
import { currentDate } from '@auteco/constants'

const useStyles = makeStyles(() => ({
    dialogContent: {
        minHeight: '200px'
    },
    input: {
        height: '32px',
        '& .MuiOutlinedInput-input': {
            padding: '8px',
        }
    },
    infoContainer: {
        margin: '12px 0 8px'
    },
    saveBtn: {
        marginLeft: '8px',
        height: '34px'
    }
}))

const AlertAddDate = ({ open, onClose, item, solicitante, updatePriorities }) => {
    const [date, setDate] = useState('')
    const [error, setError] = useState(false)

    const classes = useStyles()

    const handleClose = () => {
        setDate('')
        setError(false)
        onClose()
    }

    const postDetailedPlan = async () => {
        if (date < currentDate) {
            setError(true)
        } else {
            const body = {
                titulo: item.titulo,
                texto: item.texto,
                finalizacion: date,
                valoracion: item.valoracion,
                solicitante,
                prioridad: item.prioridad,
                cluster_id: item.cluster_id,
                punto_id: item.punto_id,
                fecha_cierre: ''
            }
            await postGDCDetaliedPlan({ params: body })
            updatePriorities()
            handleClose()
        }
    }
    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogContent className={classes.dialogContent}>
                <DialogTitle>!Espera!</DialogTitle>
                <Typography>Para guardar en plan detallado debes ingresar la fecha estimada de finalización</Typography>
                <div className={classes.infoContainer}>
                    <TextField
                        type='date'
                        variant='outlined'
                        value={date}
                        className={classes.input}
                        InputProps={{
                            inputProps: { min: currentDate },
                        }}
                        error={error}
                        helperText={error && 'La fecha estimada es menor a la fecha actual'}
                        onChange={(e) => setDate(e.target.value)}
                    />
                    <Button
                        variant='contained'
                        color='primary'
                        className={classes.saveBtn}
                        onClick={postDetailedPlan}
                    >
                        Guardar
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    )
}

export { AlertAddDate }